import { damp, clamp01 } from "@studiometa/js-toolkit/utils";
import { AbstractScrollAnimation } from "./AbstractScrollAnimation.js";
function updateProps(that, props, dampFactor, dampPrecision, axis = "x") {
  that.dampedCurrent[axis] = damp(
    props.current[axis],
    that.dampedCurrent[axis],
    dampFactor,
    dampPrecision
  );
  that.dampedProgress[axis] = clamp01(
    (that.dampedCurrent[axis] - props.start[axis]) / (props.end[axis] - props.start[axis])
  );
}
class ScrollAnimationChild extends AbstractScrollAnimation {
  /**
   * Config.
   */
  static config = {
    name: "ScrollAnimationChild",
    ...AbstractScrollAnimation.config,
    options: {
      ...AbstractScrollAnimation.config.options,
      dampFactor: {
        type: Number,
        default: 0.1
      },
      dampPrecision: {
        type: Number,
        default: 1e-3
      }
    }
  };
  /**
   * Local damped current values.
   */
  dampedCurrent = {
    x: 0,
    y: 0
  };
  /**
   * Local damped progress.
   */
  dampedProgress = {
    x: 0,
    y: 0
  };
  /**
   * Compute local damped progress.
   */
  scrolledInView(props) {
    const { dampFactor, dampPrecision } = this.$options;
    updateProps(this, props, dampFactor, dampPrecision, "x");
    updateProps(this, props, dampFactor, dampPrecision, "y");
    props.dampedCurrent = this.dampedCurrent;
    props.dampedProgress = this.dampedProgress;
    super.scrolledInView(props);
  }
}
export {
  ScrollAnimationChild
};
//# sourceMappingURL=ScrollAnimationChild.js.map
